import React from 'react'

import { useRouter } from 'next/router'

import * as S from './styles'
import { ImageAnimation } from '@/components'
import { CultureHeroData } from '@/service/api/culturePage/types'
import { defaultTheme } from '@/styles/themes'

type CultureHeroContainerProps = {
  /**
   * The data of CultureHeroContainer
   *
   * @example
   * ```tsx
   * const data = {
   *  ...
   * }
   *
   * <CultureHeroContainer data={data} />
   * ```
   */
  cultureHeroData: CultureHeroData
}

export const CultureHeroContainer: React.FC<CultureHeroContainerProps> = ({
  cultureHeroData,
}) => {
  const router = useRouter()

  return (
    <S.CultureHeroContainer>
      <S.TextContainer>
        {cultureHeroData.title && (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 150 40"
            xmlns="http://www.w3.org/2000/svg"
            fontFamily={defaultTheme.fontFamily.secondary}
            overflow="visible"
          >
            <text
              fill="transparent"
              strokeWidth="0.02rem"
              stroke={defaultTheme.colors.primary}
              fontSize="1.3rem"
              textAnchor="middle"
              dominantBaseline="central"
            >
              {cultureHeroData.title
                .split('\n')
                .map((el: string, i: number) => (
                  <tspan
                    y={`${50 / cultureHeroData.title.split('\n').length}%`}
                    x="50%"
                    dy={`${i}.1em`}
                    key={el}
                  >
                    {el}
                  </tspan>
                ))}
            </text>
          </svg>
        )}
      </S.TextContainer>

      {cultureHeroData.images.length > 0 && (
        <ImageAnimation
          imagesUrl={cultureHeroData.images}
          key={`imageAnimation${router.locale}`} // prevent image misplacement after locale change
        />
      )}
    </S.CultureHeroContainer>
  )
}
